export default "__VITE_ASSET__BNqcEp9n__"